import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import { Menu, Container, Button, Dropdown } from 'semantic-ui-react';
import LoginForm from '../user/LoginForm';
import { useStore } from '../../app/stores/store';
import RegisterForm from '../user/RegisterForm';
import { isMobileOnly } from 'react-device-detect';

export default observer(function HomeNavBar() {
    const {modalStore} = useStore();
    const {openModal} = modalStore;

    return (
        <Menu 
            fixed='top' 
            borderless
            className='home-navbar'
            size='huge'
        >
            <Container>
                {isMobileOnly ? (<>
                    {/* only mobile */}
                    <Menu.Item position='left' className='mobile-menu-bar'>
                        <Dropdown pointing='top left' icon='bars' >
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => openModal(<RegisterForm isRedirect={false} />)}
                                    text='JOIN' icon='signup' />
                                <Dropdown.Item onClick={() => openModal(<LoginForm />)}
                                    text='SIGN IN' icon='sign in' />
                            </Dropdown.Menu>
                        </Dropdown>
                    </Menu.Item>
                    <Menu.Item header as={Link} to='/'>
                        <img src={`${process.env.PUBLIC_URL}/assets/banner.png`} alt='logo' className='logo-img' style={{ width: '300px' }} />
                    </Menu.Item>
                    </>) :
                    // rest devices
                    (<>
                    <Menu.Item header as={Link} to='/'>
                        <img src={`${process.env.PUBLIC_URL}/assets/banner.png`} alt='logo' style={{ width: '300px' }} />
                    </Menu.Item>
                    <Menu.Menu position='right'>
                        <Menu.Item>
                            <Button
                                onClick={() => openModal(<RegisterForm isRedirect={false} />)}
                                positive
                                content="JOIN" />
                        </Menu.Item>
                        <Menu.Item>
                            <Button 
                                onClick={() => openModal(<LoginForm />)}
                                positive 
                                content="SIGN IN" />
                        </Menu.Item>
                    </Menu.Menu>
                    </>)
                }
            </Container>
        </Menu>
    )
})